<template>
    <div class="m-auto max-w-7xl">
        <Table :filters="queryBuilderProps.filters" :search="queryBuilderProps.search" :columns="queryBuilderProps.columns" :on-update="setQueryBuilder" :meta="posts">
            <template #head>
                <tr>
                    <th>Challenge</th>
                    <th v-show="showColumn('created_at')" @click.prevent="sortBy('created_at')">Created</th>
                </tr>
            </template>

            <template #body>
                <tr v-for="post in posts.data" :key="post.id">
                    <td>{{ post.text | trim(50) }}</td>
                    <td v-show="showColumn('created_at')">{{ post.created_at }}</td>
                </tr>
            </template>
        </Table>
    </div>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout"
import { InteractsWithQueryBuilder, Tailwind2 } from "@protonemedia/inertiajs-tables-laravel-query-builder"

export default {
    layout: AdminLayout,

    mixins: [InteractsWithQueryBuilder],

    components: {
        Table: Tailwind2.Table,
    },

    props: {
        posts: Object,
    },
}
</script>
